export default () => ({
    stream: null,
    streamError: null,
    streamLastEventId: undefined,
})